import { isBot as isBotBrowser, isAutomated } from '../browser'

/**
 * Checks if the current client is a bot — by user-agent ({@link isBotBrowser})
 * OR by an automation signal (`navigator.webdriver`, {@link isAutomated}).
 * @returns A Promise that resolves to true if the client looks like a bot.
 * @example
 * ```ts
 * if (!(await montilla.isBot())) {
 *   montilla.track('user_interaction', { type: 'click' })
 * }
 * ```
 */
export function isBot(): Promise<boolean> {
  return Promise.resolve(isBotBrowser(navigator.userAgent) || isAutomated())
}
